module.exports = fox._r("images/banner-cam-shadow.png", __webpack_public_path__ + "images/banner-cam-shadow.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/banner-cam-shadow.png
// module id = 987
// module chunks = 4